import { render } from "./ProfileNav.vue?vue&type=template&id=6a484ad0"
import script from "./ProfileNav.vue?vue&type=script&lang=js"
export * from "./ProfileNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__